import { render, staticRenderFns } from "./GeneralInformation.component.vue?vue&type=template&id=0bf89b3e&scoped=true"
import script from "./GeneralInformation.component.vue?vue&type=script&lang=js"
export * from "./GeneralInformation.component.vue?vue&type=script&lang=js"
import style0 from "./GeneralInformation.component.vue?vue&type=style&index=0&id=0bf89b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf89b3e",
  null
  
)

export default component.exports